module.exports = __webpack_public_path__ + "static/img/15-3.47b5944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/15-3.jpg
// module id = MHi6
// module chunks = 0